import { ObjectMapper } from "json-object-mapper";
import { InsightModel } from "./insight.model";

export class InsightSesmtModel extends InsightModel {

  static create(input: any): InsightSesmtModel {
    return ObjectMapper.deserialize<InsightSesmtModel>(InsightSesmtModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}